import axios from "axios";

const baseURLV2 =
  process.env.REACT_APP_BASE_URL_V2 || "https://stagingapi.obenan.com/api/v1";

export const apiV2 = axios.create({
  baseURL: baseURLV2,
  responseType: "json",
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "x-csrfoken",
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("accessToken")}`,
  },
});
apiV2.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("accessToken");

  config.headers.Authorization = "Bearer " + token;
  return config;
});

export default apiV2;
